import { motion } from "framer-motion";
import * as Icons from "lucide-react";
import { TOOLS } from "@/data/content";

export const Tools = () => {
  return (
    <section id="tools" className="relative bg-background py-20 lg:py-28">
      <div className="mx-auto max-w-7xl px-5 lg:px-8">
        {/* Section header */}
        <div className="mx-auto max-w-2xl text-center">
          <span className="inline-block rounded-full bg-primary/10 px-4 py-1.5 text-xs font-bold uppercase tracking-widest text-primary">
            Proven Methods
          </span>
          <h2 className="section-title mt-4 text-foreground">
            What Makes Us <span className="text-gradient-primary">Different</span>
          </h2>
          <p className="mt-4 text-base text-muted-foreground md:text-lg">
            Most candidates fail not because they lack skills, but because they don't know how to sell them. We bridge that gap with proven, psychology backed methods.
          </p>
        </div>

        {/* Cards grid */}
        <div className="mt-14 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {TOOLS.map((tool, i) => {
            const Icon = Icons[tool.icon] || Icons.Sparkles;
            return (
              <motion.div
                key={tool.name}
                initial={{ opacity: 0, y: 28 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-50px" }}
                transition={{ duration: 0.5, delay: (i % 3) * 0.1 }}
                className="group flex flex-col rounded-2xl border border-border bg-white p-7 shadow-sm transition-all duration-300 hover:-translate-y-1 hover:border-primary/40 hover:shadow-md"
              >
                <span className="inline-flex h-13 w-13 h-[52px] w-[52px] items-center justify-center rounded-xl bg-primary/10 text-primary transition-all group-hover:bg-primary group-hover:text-white">
                  <Icon className="h-6 w-6" />
                </span>
                <span className="mt-3 self-start rounded-full bg-secondary px-3 py-0.5 text-[11px] font-semibold uppercase tracking-wide text-muted-foreground">
                  {tool.tag}
                </span>
                <h3 className="mt-3 font-display text-xl font-bold text-foreground">{tool.name}</h3>
                <p className="mt-2 text-sm leading-relaxed text-muted-foreground">{tool.desc}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
